import $ from 'jquery';

/**
 * Sliding menu is the new mobile navigation for Global Navigation project,
 * a.k.a Header Footer Navigation.
 *
 * This new navigation is triggered via touch on burger icon and dispatch some
 * events that are used for preventing scroll
 *
 * @return {undefined}
 */
export function bindListenersToSlidingMenu() {
  $(document).ready(function() {
    const $html = $('html');

    $.subscribe('mobile-navigation:menu-opened', () => {
      $html.addClass('prevent-scrolling');
    });

    $.subscribe('mobile-navigation:menu-closed', () => {
      $html.removeClass('prevent-scrolling');
    });
  });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/home24.slidingMenu.js
 **/